import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8h4l-2 8","key":"svg-1"}]]

const IconCircleNumber7 = createReactComponent('outline', 'circle-number-7', 'CircleNumber7', __iconNode);

export default IconCircleNumber7;